import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { switchMap, take } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ENVIRONMENT_CONFIG } from '@web-client/shared';
import { isPlatformBrowser } from '@angular/common';

/**
 * Auth Interceptor (Functional Interceptor)
 * Automatically adds Bearer token to outgoing HTTP requests
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const environment = inject(ENVIRONMENT_CONFIG);
    const oidcSecurityService = inject(OidcSecurityService);
    const platformId = inject(PLATFORM_ID);

    // Skip adding token if running on server (SSR)
    if (!isPlatformBrowser(platformId)) {
        return next(req);
    }

    // Skip adding token for non-API requests or external URLs
    const apiResource = (environment as any).apiResource || '';
    if (apiResource && !req.url.startsWith(apiResource)) {
        return next(req);
    }

    // Get token directly from OIDC service on each request
    return oidcSecurityService.getAccessToken().pipe(
        take(1),
        switchMap(token => {
            if (token) {
                // Clone request and add Authorization header
                req = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }
            return next(req);
        })
    );
};
